import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const StudentNotifications = () => {
  const routes = all_routes;
  const [filterType, setFilterType] = useState("all");

  // Mock notifications data
  const notificationsData = [
    {
      id: "1",
      type: "academic",
      title: "Math Test Scheduled",
      message:
        "Mathematics test scheduled for tomorrow at 10:00 AM in Room 201",
      timestamp: "2024-08-20 14:30",
      read: false,
      priority: "high",
      from: "Ms. Johnson",
    },
    {
      id: "2",
      type: "homework",
      title: "Physics Assignment Due",
      message: "Lab report submission deadline is today at 5:00 PM",
      timestamp: "2024-08-20 09:15",
      read: false,
      priority: "high",
      from: "Dr. Smith",
    },
    {
      id: "3",
      type: "grades",
      title: "Grade Updated",
      message: "Your English essay grade has been updated: A-",
      timestamp: "2024-08-19 16:00",
      read: true,
      priority: "medium",
      from: "Mr. Davis",
    },
    {
      id: "4",
      type: "event",
      title: "Science Fair Registration",
      message: "Registration for Science Fair 2024 is now open until Friday",
      timestamp: "2024-08-19 10:30",
      read: true,
      priority: "medium",
      from: "School Admin",
    },
    {
      id: "5",
      type: "attendance",
      title: "Attendance Alert",
      message: "You have been marked present for all classes today",
      timestamp: "2024-08-18 15:45",
      read: true,
      priority: "low",
      from: "Attendance System",
    },
    {
      id: "6",
      type: "system",
      title: "Schedule Change",
      message: "History class has been moved to Room 302 for this week",
      timestamp: "2024-08-18 12:20",
      read: false,
      priority: "medium",
      from: "Ms. Wilson",
    },
  ];

  const filteredNotifications =
    filterType === "all"
      ? notificationsData
      : notificationsData.filter((notif) => notif.type === filterType);

  const unreadCount = notificationsData.filter((notif) => !notif.read).length;

  const getNotificationIcon = (type: string) => {
    switch (type) {
      case "academic":
        return "ti-book";
      case "homework":
        return "ti-clipboard-list";
      case "grades":
        return "ti-trophy";
      case "event":
        return "ti-calendar-event";
      case "attendance":
        return "ti-user-check";
      case "system":
        return "ti-settings";
      default:
        return "ti-bell";
    }
  };

  const getNotificationColor = (type: string) => {
    switch (type) {
      case "academic":
        return "bg-primary";
      case "homework":
        return "bg-warning";
      case "grades":
        return "bg-success";
      case "event":
        return "bg-info";
      case "attendance":
        return "bg-secondary";
      case "system":
        return "bg-danger";
      default:
        return "bg-primary";
    }
  };

  const getPriorityBadge = (priority: string) => {
    switch (priority) {
      case "high":
        return "bg-danger";
      case "medium":
        return "bg-warning";
      case "low":
        return "bg-info";
      default:
        return "bg-secondary";
    }
  };

  const renderNotificationCard = (notification: any) => {
    return (
      <div
        key={notification.id}
        className={`card mb-3 ${!notification.read ? "border-primary" : ""}`}
      >
        <div className="card-body">
          <div className="d-flex align-items-start">
            <div
              className={`avatar avatar-sm me-3 ${getNotificationColor(
                notification.type
              )}`}
            >
              <i
                className={`ti ${getNotificationIcon(
                  notification.type
                )} text-white`}
              ></i>
            </div>
            <div className="flex-fill">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className={`mb-0 ${!notification.read ? "fw-bold" : ""}`}>
                  {notification.title}
                  {!notification.read && (
                    <span className="badge bg-primary ms-2">New</span>
                  )}
                </h6>
                <span
                  className={`badge ${getPriorityBadge(notification.priority)}`}
                >
                  {notification.priority.charAt(0).toUpperCase() +
                    notification.priority.slice(1)}
                </span>
              </div>
              <p className="text-muted mb-2">{notification.message}</p>
              <div className="d-flex align-items-center justify-content-between">
                <small className="text-muted">
                  <i className="ti ti-user me-1"></i>
                  {notification.from}
                </small>
                <small className="text-muted">
                  <i className="ti ti-clock me-1"></i>
                  {new Date(notification.timestamp).toLocaleString()}
                </small>
              </div>
              {!notification.read && (
                <button className="btn btn-primary btn-sm mt-2">
                  <i className="ti ti-check me-1"></i>
                  Mark as Read
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Notifications</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card bg-warning">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Notifications</h3>
                      <p>Stay updated with alerts and system messages</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-bell text-white fs-1"></i>
                      {unreadCount > 0 && (
                        <span className="badge bg-danger position-absolute top-0 end-0">
                          {unreadCount}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row">
            <div className="col-sm-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-danger-transparent mb-3">
                    <i className="ti ti-bell-ringing fs-2 text-danger"></i>
                  </div>
                  <h4 className="text-danger">{unreadCount}</h4>
                  <p className="mb-0">Unread</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-warning-transparent mb-3">
                    <i className="ti ti-alert-triangle fs-2 text-warning"></i>
                  </div>
                  <h4 className="text-warning">
                    {
                      notificationsData.filter((n) => n.priority === "high")
                        .length
                    }
                  </h4>
                  <p className="mb-0">High Priority</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-success-transparent mb-3">
                    <i className="ti ti-check fs-2 text-success"></i>
                  </div>
                  <h4 className="text-success">
                    {notificationsData.filter((n) => n.read).length}
                  </h4>
                  <p className="mb-0">Read</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-info-transparent mb-3">
                    <i className="ti ti-bell fs-2 text-info"></i>
                  </div>
                  <h4 className="text-info">{notificationsData.length}</h4>
                  <p className="mb-0">Total</p>
                </div>
              </div>
            </div>
          </div>

          {/* Filter and Actions */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="card-title mb-0">All Notifications</h5>
                    <div className="d-flex gap-2">
                      <button className="btn btn-success btn-sm">
                        <i className="ti ti-check me-1"></i>
                        Mark All Read
                      </button>
                      <div className="dropdown">
                        <button
                          className="btn btn-outline-primary btn-sm dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          Filter:{" "}
                          {filterType === "all" ? "All Types" : filterType}
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => setFilterType("all")}
                            >
                              All Types
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => setFilterType("academic")}
                            >
                              Academic
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => setFilterType("homework")}
                            >
                              Homework
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => setFilterType("grades")}
                            >
                              Grades
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => setFilterType("event")}
                            >
                              Events
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {filteredNotifications.length > 0 ? (
                    filteredNotifications.map((notification) =>
                      renderNotificationCard(notification)
                    )
                  ) : (
                    <div className="text-center py-4">
                      <div className="avatar avatar-lg bg-light mb-3">
                        <i className="ti ti-bell-off fs-2 text-muted"></i>
                      </div>
                      <h5>No notifications</h5>
                      <p className="text-muted">
                        No notifications found for the selected filter.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentNotifications;
